import React from "react";
import { Users, Award, BookOpen } from "lucide-react";

const HeroClinicalActivities = () => {
  return (
    <div className="relative bg-slate-900 py-24 px-4 md:px-10 border-t border-white/5 overflow-hidden">
      {/* Background Image Background (Audience) */}
      <div 
        className="absolute inset-0 opacity-20 bg-cover bg-center grayscale" 
        style={{ backgroundImage: "url('/assets/audience-bg.jpg')" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h3 className="text-amber-500 font-black uppercase tracking-[0.3em] text-sm">Clinical Activities</h3>
          <p className="text-white/70 max-w-3xl mx-auto text-xs md:text-sm leading-relaxed italic font-medium">
            "Together, we can turn differences into strengths, barriers into opportunities, and ensure that every patient's unique needs are met with compassion, innovation, and excellence."
          </p>
        </div>

        {/* Icon Categories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-4xl mx-auto">
          {[
            { icon: Users, label: "Symposium" },
            { icon: Award, label: "Workshop" },
            { icon: BookOpen, label: "Competition" }
          ].map((item, idx) => (
            <div key={idx} className="flex flex-col items-center group cursor-default">
              <div className="w-20 h-20 mb-4 flex items-center justify-center text-white border border-white/10 rounded-full group-hover:bg-amber-500 group-hover:border-amber-500 group-hover:shadow-[0_0_30px_rgba(245,158,11,0.3)] transition-all duration-500">
                <item.icon size={36} strokeWidth={1.5} />
              </div>
              <span className="bg-amber-500/10 text-amber-500 px-8 py-1.5 text-[10px] font-black uppercase tracking-widest rounded-full border border-amber-500/20">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        {/* Detail Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 border-t border-white/10 pt-16">
          {[
            { t: "World-Class Expertise", d: "Insights from renowned specialists from cardiovascular centers worldwide." },
            { t: "Actionable Insights", d: "Practical strategies to inspire meaningful improvements in cardiovascular care." },
            { t: "Collaborative Workshops", d: "Hands-on sessions in advanced techniques designed to enhance technical precision.", highlight: true },
            { t: "Posters & Case Reports", d: "A platform for researchers to showcase innovations that advance cardio care." }
          ].map((feature, i) => (
            <div key={i} className={`space-y-3 text-center md:text-left ${feature.highlight ? 'md:border-l md:border-amber-500/30 md:pl-8' : ''}`}>
              <h4 className="text-amber-500 font-black text-[11px] uppercase tracking-wider">{feature.t}</h4>
              <p className="text-white/40 text-[11px] leading-relaxed font-medium">{feature.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroClinicalActivities;